import React from 'react'
import { useHistory } from 'react-router-dom'

export default function AristCover(props) {
  const history = useHistory()

  function searchOnClick() {
    history.push(`/artist/${props.artis.strArtist}`)
  }

  return (
    <div>
      {/* {JSON.stringify(props.listArtist)} */}
      <div className="card" style={{ width: "18rem", color: 'black' }}>
        <img
        onClick={searchOnClick}
        className="card-img-top" src={props.artis.strArtistThumb} alt={props.artis.strArtist} />
        <div className="card-body">
          <h5 className="card-title">{props.artis.strArtist}</h5>
        </div>
      </div>
    </div>
  )
}
